/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import {
  PROPERTY_PARSE_SUCCESS,
  PROPERTY_PARSE_FAILURE
} from '../actions/actionTypes';

const initialState = {
  parsed:{},
  parseType:"",
}

export default function (state = initialState, action) {
  switch (action.type) {
    case PROPERTY_PARSE_SUCCESS:
      return {
        propertyParseSuccess: true,
        parsed: action.payload.data,
        parseType: action.payload.parseType,
      }
    case PROPERTY_PARSE_FAILURE:
      return {
        propertyParseSuccess: false,
        parsed: {},
        error: action.errResp.message,
        parseType: "",

      }
    default:
      return state;
  }
}
